import dynamic from 'next/dynamic';
import QuestionKalenderKehamilan from 'src/containers/KalenderKehamilan';
const HeadC = dynamic(() => import('src/components/Head'));
const LoginPage = () => {
  return <>
			<HeadC title="Kalkulator Masa Subur Wanita Online Akurat" description={'Cek masa subur Mama dengan kalkulator online Hallobumil. ' + 'Bantu tingkatkan peluang hamil dengan perhitungan yang cepat, praktis, dan akurat.'} />
			<QuestionKalenderKehamilan />
		</>;
};
export default LoginPage;